import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { N58Service } from '../../../services/n58.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-n58-monto-min-modal',
  templateUrl: './n58-monto-min-modal.component.html',
})
export class N58MontoMinModalComponent implements OnInit {
  form: FormGroup;
  loading = false;
  loadingActual = true;
  valorActual: number | null = null;

  constructor(
    private n58: N58Service,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<N58MontoMinModalComponent>,
  ) {
    this.form = this.fb.group({
      valor: new FormControl(null, [
        Validators.required,
        Validators.min(1),
        Validators.pattern(/^[0-9]+$/),
      ]),
    });
  }

  ngOnInit(): void {
    this.n58.getMontoMin().subscribe({
      next: (res) => {
        this.valorActual = res?.valor ?? null;
        if (this.valorActual !== null) {
          this.form.patchValue({ valor: this.valorActual });
        }
        this.loadingActual = false;
      },
      error: () => {
        this.loadingActual = false;
      },
    });
  }

  formatVES(amount: number | null | undefined): string {
    if (amount === null || amount === undefined) return '-';
    return new Intl.NumberFormat('es-VE', {
      style: 'currency',
      currency: 'VES',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  }

  guardar(): void {
    if (this.form.invalid || this.loading) return;

    const raw = this.form.get('valor')?.value;
    const valor = parseInt(String(raw), 10);
    if (!Number.isInteger(valor) || valor <= 0) {
      Swal.fire({
        icon: 'error',
        title: 'Valor inválido',
        text: 'El monto mínimo debe ser un número entero positivo (sin puntos ni decimales).',
        confirmButtonColor: '#1e5a3f',
      });
      return;
    }

    this.loading = true;
    this.n58.updateMontoMin(valor).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: 'Monto mínimo actualizado',
          html: `<p>Nuevo valor: <strong>${this.formatVES(res?.valor ?? valor)}</strong></p>`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#1e5a3f',
        });
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.loading = false;
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err?.error?.message || err?.message || 'No se pudo actualizar el monto mínimo',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#1e5a3f',
        });
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
